var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoGrad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.6253 36.3981C54.3741 35.4343 56.574 36.0731 57.5375 37.8258C58.501 39.5784 57.8633 41.7782 56.1118 42.7392C54.3602 43.703 52.1603 43.0642 51.1968 41.3143C50.2333 39.5617 50.8738 37.3619 52.6253 36.3981ZM49.5511 23.2853C48.7602 24.5075 47.6297 25.4879 46.2958 26.0879C45.4298 26.4795 44.6501 26.985 43.9734 27.5877C44.4524 28.1433 44.8728 28.746 45.2293 29.3932L45.3295 29.5792C46.5743 31.8374 46.8917 34.5094 46.1399 36.9758C45.4938 39.1006 45.6692 41.4754 46.8249 43.5753C49.1612 47.8249 54.5858 49.297 58.7711 46.7389C62.5415 44.4335 63.9255 39.545 61.9261 35.6037C60.79 33.365 58.8184 31.8513 56.5963 31.2347C54.1068 30.5431 52.0155 28.8488 50.7708 26.5851L50.587 26.2518C50.0746 25.3185 49.7321 24.3186 49.5511 23.2853Z",
    fill: "url(#paint0_linear_458_650)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9635 17.4337C40.9242 15.6838 43.1241 15.0422 44.8784 16.0033C46.63 16.9643 47.2705 19.1641 46.307 20.9167C45.3463 22.6694 43.1464 23.311 41.3948 22.3472C39.6433 21.3861 39.0028 19.1863 39.9635 17.4337ZM34.603 30.0882C36.6859 30.6659 38.5071 31.9297 39.7881 33.6406C39.8772 32.2269 40.2782 30.8353 40.9715 29.5715L41.1553 29.2382C42.1912 27.3495 43.8398 25.8885 45.8029 25.0025C47.1257 24.4081 48.259 23.3582 48.9496 21.9333C50.3865 18.9613 49.2977 15.3255 46.4657 13.6285C43.319 11.7425 39.2645 12.8619 37.5158 16.0477C36.8085 17.3393 36.5885 18.7669 36.7973 20.1196C37.1315 22.2777 36.6804 24.4831 35.6306 26.3996L35.5275 26.5829C34.9093 27.7134 34.0767 28.7049 33.0909 29.4965C33.5727 29.7437 34.0795 29.9409 34.603 30.0882Z",
    fill: "url(#paint1_linear_458_650)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3188 36.3981C32.0703 35.4343 34.2702 36.0731 35.2337 37.8258C36.1972 39.5784 35.5568 41.7782 33.8052 42.7392C32.0564 43.703 29.8538 43.0642 28.893 41.3143C27.9295 39.5617 28.5672 37.3619 30.3188 36.3981ZM27.2473 23.2853C26.4537 24.5075 25.3259 25.4879 23.992 26.0879C23.126 26.4795 22.3463 26.985 21.6696 27.5877C22.1486 28.1433 22.5691 28.746 22.9227 29.3932L23.0257 29.5792C24.2677 31.8374 24.5879 34.5094 23.8361 36.9758C23.19 39.1006 23.3655 41.4754 24.5211 43.5753C26.8574 47.8249 32.282 49.297 36.4673 46.7389C40.2378 44.4335 41.6218 39.545 39.6196 35.6037C38.4862 33.365 36.5147 31.8513 34.2897 31.2347C31.803 30.5431 29.7117 28.8488 28.467 26.5851L28.2832 26.2518C27.7708 25.3185 27.4283 24.3186 27.2473 23.2853Z",
    fill: "url(#paint2_linear_458_650)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.133667 34.9303C0.222775 34.7442 0.317455 34.5553 0.417702 34.372C1.35892 32.6583 2.71784 31.2751 4.35801 30.3196C5.22682 15.8097 17.2705 4.30796 31.9986 4.30796C46.7267 4.30796 58.7676 15.807 59.6392 30.314C61.3824 31.3334 62.8221 32.8416 63.7522 34.6748C63.7911 34.7525 63.8274 34.8331 63.8663 34.9136C63.9527 33.9554 64 32.9832 64 32C64 14.3265 49.6729 0 31.9986 0C14.3271 0 3.8147e-06 14.3265 3.8147e-06 32C3.8147e-06 32.9888 0.0473404 33.9665 0.133667 34.9303ZM53.0646 49.9762C47.9854 55.9229 40.4334 59.692 31.9986 59.692C23.5666 59.692 16.0118 55.9201 10.9326 49.9734C10.5177 50.0234 10.0972 50.0512 9.67393 50.0512C8.05604 50.0512 6.49942 49.6929 5.05139 48.9819C4.96228 48.9374 4.87595 48.8902 4.78963 48.8458C10.4314 57.9422 20.5063 64 31.9986 64C43.4909 64 53.5686 57.9394 59.2104 48.843C57.6955 49.6346 56.0164 50.0512 54.3121 50.0512C53.8917 50.0512 53.474 50.0234 53.0646 49.9762Z",
    fill: "url(#paint3_linear_458_650)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46568 37.8344C7.42917 36.0818 9.62906 35.4401 11.3806 36.4039C13.1322 37.365 13.7726 39.5648 12.8119 41.3174C11.8512 43.0673 9.65134 43.7089 7.897 42.7478C6.14544 41.7868 5.50497 39.587 6.46568 37.8344ZM17.66 17.4389C18.6208 15.6891 20.8206 15.0475 22.5722 16.0085C24.3265 16.9695 24.967 19.1693 24.0035 20.922C23.0428 22.6746 20.8429 23.3162 19.0914 22.3524C17.3398 21.3914 16.6993 19.1916 17.66 17.4389ZM5.95052 47.1391C9.91866 49.0834 14.7863 47.6307 17.0418 43.8255C18.32 41.6674 18.54 39.1926 17.8689 36.9845C17.117 34.5152 17.4261 31.8405 18.6681 29.5768L18.8519 29.2435C19.8878 27.3547 21.5363 25.8938 23.4995 25.0077C24.8222 24.4133 25.9556 23.3634 26.6462 21.9385C28.0803 18.9666 26.9942 15.3308 24.1622 13.6337C21.0156 11.7478 16.9611 12.8671 15.2123 16.0529C14.5022 17.3445 14.285 18.7722 14.4939 20.1248C14.8252 22.283 14.3769 24.4883 13.3271 26.4048L13.2241 26.5881C11.9849 28.8518 9.89917 30.5517 7.41525 31.2405C5.27384 31.8349 3.36635 33.257 2.21349 35.3568C-0.120058 39.6092 1.54517 44.9782 5.95052 47.1391Z",
    fill: "url(#paint4_linear_458_650)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_458_650",
    x1: 53.4066,
    y1: 48,
    x2: 53.4066,
    y2: 23.2853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A58CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D6EFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_458_650",
    x1: 41.3365,
    y1: 33.6406,
    x2: 41.3365,
    y2: 12.7095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A58CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D6EFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_458_650",
    x1: 31.1024,
    y1: 48,
    x2: 31.1024,
    y2: 23.2853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A58CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D6EFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_458_650",
    x1: 32,
    y1: 64,
    x2: 32,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A58CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D6EFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_458_650",
    x1: 14.2179,
    y1: 48,
    x2: 14.2179,
    y2: 12.7147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A58CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D6EFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGrad);
export default __webpack_public_path__ + "static/media/logo_grad.cae022bac38e3daee3a49a3ca050735f.svg";
export { ForwardRef as ReactComponent };